import { render, staticRenderFns } from "./IconXSolid.vue?vue&type=template&id=4432b05e"
import script from "./IconXSolid.vue?vue&type=script&lang=js"
export * from "./IconXSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports